import classNames from './AppLoader.module.scss';
import { useAdminTranslation } from '@/admin/hooks/useAdminTranslation';
import AppLoaderCircle from '@/components/AppLoaderCircle';

const AppLoader = () => {
  const { t } = useAdminTranslation();

  return (
    <div className={classNames.appLoader}>
      <div className={classNames.appLoaderText}>
        {t('helloLoader')}
        <br />
        {t('appTitle')}
      </div>
      <AppLoaderCircle />
    </div>
  );
};

export default AppLoader;
